import { render, staticRenderFns } from "./RiskSeverityComponent.vue?vue&type=template&id=0c6f3ee8&scoped=true&"
import script from "./RiskSeverityComponent.vue?vue&type=script&lang=js&"
export * from "./RiskSeverityComponent.vue?vue&type=script&lang=js&"
import style0 from "./RiskSeverityComponent.vue?vue&type=style&index=0&id=0c6f3ee8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f3ee8",
  null
  
)

export default component.exports